export const sportsWithAnimations = new Set([
    "Soccer",
    "Tennis",
    "Basketball",
    "Volleyball",
    "Cricket",
    "Baseball",
    "Hockey",
    "Handball",
    "AmericanFootball",
    "RugbyUnion",
    "RugbyLeague",
    "Darts",
    "WaterPolo",
    "IceHockey"
]);